function Features() {
    return (
        <section id="funkcje" className="features-section">
            <div className="features-container">
                <h2 className="features-title">
                    Twój wirtualny pamiętnik z podróży!
                </h2>
                <p className="features-description">
                    Projekt Tradiworld powstał z myślą o miłośnikach podróżowania, ale i nie tylko... <br />
                    Tu możesz przechowywać notatki, fotografie oraz niezapomniane chwile w jednym miejscu! Za pomocą interaktywnego globusa łatwo i szybko odnajdziesz wycieczkę do której chcesz wrócić wspomnieniami.
                </p>

                {/* Trzy szerokie kafelki obok siebie */}
                <div className="grid-container">

                    <div className="card">
                        <div className="card-icon">🌍</div>
                        <h3 className="card-title">Interaktywny globus</h3>
                        <p className="card-text">Odkrywaj świat w trzech wymiarach. Obracaj, przybliżaj i klikaj, aby w ułamek sekundy dotrzeć do każdego państwa.</p>
                    </div>

                    <div className="card-featured">
                        <div className="card-icon">⚡</div>
                        <h3 className="card-title-featured">Łatwa i prosta obsługa</h3>
                        <p className="card-text">Nie potrzebujesz instrukcji. Intuicyjny interfejs sprawia, że poruszanie się po mapie kulturowej globu jest czystą przyjemnością dla każdego.</p>
                    </div>

                    <div className="card">
                        <div className="card-icon">📊</div>
                        <h3 className="card-title">Wszystko w jednym miejscu</h3>
                        <p className="card-text">Gromadź wpomnienia oraz uchwycone obiektywem chwile z niezapomnianych wakacji w jednym miejscu.</p>
                    </div>

                </div>
            </div>
        </section>
    )

}

export default Features;